import { IBaseUIComponents } from '../../architecture/orbit-theme.interface';
import { IButtonPreset, ButtonPreset } from '../../../basic-ui-components/button/base/button-props.interface';
import {IGeneralColors} from "../../architecture/sections/general-colors.interface";
import {hexToRgba} from "../../hex-to-rgba";
import {baseColors} from './base-colors';


export function createShellBaseUIComponents(generalColors: IGeneralColors, defaults: IBaseUIComponents): IBaseUIComponents {
    let buttonPresets: Record<ButtonPreset, IButtonPreset> = {
        special: {
            colors: {
                normal: {
                    text: generalColors.textDark, bg: baseColors.gold, border: baseColors.gold,
                    bgGradient: baseColors.base04
                },
            },
            stroke: 'none'
        },
        specialInverted: {
            colors: {
                normal: {
                    text: generalColors.brandSecondaryDark, bg: baseColors.gold, border: baseColors.gold,
                    bgGradient: baseColors.base04
                },
                hover: {
                    text: baseColors.gold,  bg: generalColors.backgroundDark, border: baseColors.gold,
                    textGradient: baseColors.base04
                }
            },
            stroke: 'none'
        },
        primary: {
            colors: {
                normal: {
                    text: generalColors.textDark, bg: generalColors.brandSecondaryLight, border: generalColors.brandSecondaryLight
                },
            }
        },
        secondary: {
            colors: {
                normal: {
                    text: generalColors.brandSecondaryLight,  bg: "transparent", border: generalColors.brandSecondaryLight
                },
                hover: 10
            }
        },
        info: {
            colors: {
                normal: {
                    text: generalColors.textLight,  bg: generalColors.background, border: generalColors.boxBorderLighter
                },
            }
        },
        warning: {
            colors: {
                normal: {
                    text: generalColors.textLight, bg: generalColors.backgroundDark, border: generalColors.boxBorderContrast
                },
            }
        },
        flatStroked: {
            colors: {
                normal: {
                    text: generalColors.textLight, bg: generalColors.iconBackgroundActive, border: generalColors.backgroundLight
                },
                disabled: {
                    text: hexToRgba(generalColors.brandPrimary,0.5), bg: generalColors.iconBackgroundActive, border: hexToRgba(generalColors.brandPrimary,0.5)
                }
            },
            stroke: "heavy"
        }
    }

    return {
        ...defaults,
        button: {
            ...defaults.button,
            presets: buttonPresets,
            disabledColorSet: {
                text: generalColors.buttonInfo, bg: baseColors.gray033, border: baseColors.gray033
            },
            defaults: {
                ...defaults.button.defaults,
                rounded: true
            }
        }
    };
}